import { render, staticRenderFns } from "./RepairPlanCommentsRegisterPage.vue?vue&type=template&id=96d7c19e&"
import script from "./RepairPlanCommentsRegisterPage.vue?vue&type=script&lang=ts&"
export * from "./RepairPlanCommentsRegisterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports